/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Refine_StaleInputs */



/**
* | output |
* | --- |
* | "You changed the text while Uno was refining, so your version is kept." |
*
* @param {Agent_Wizard_Refine_StaleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_refine_stale = /** @type {((inputs?: Agent_Wizard_Refine_StaleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Refine_StaleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben den Text geändert, während Uno ihn überarbeitet hat. Ihre Fassung bleibt erhalten.")
	return /** @type {LocalizedString} */ ("You changed the text while Uno was refining, so your version is kept.")
});